import React, {
  useMemo,
} from 'react';
import {
  useNavigate,
} from 'react-router';

import {
  Flex,
} from 'web-styled';

import Tag from './styled';

type Props = {
  tags: string[],
  resourceType: string,
};

const TagList = ({ tags, resourceType }: Props) => {
  const navigate = useNavigate();
  const sorted = useMemo(() => (tags ? tags.sort() : []), [tags]);
  return tags ? (
    <Flex
      wrap="wrap"
      align="center"
      spacing={6}
    >
      {sorted.map((tag: string) => (
        <Tag
          key={tag}
          onClick={() => navigate(`/tags/${tag}/${resourceType}?back=${window.location.pathname}`)}
        >
          {tag}
        </Tag>
      ))}
    </Flex>
  ) : null;
};

export default TagList;
